// extracted by mini-css-extract-plugin
export var errorIcon = "_kz-1";
export var nameLogo = "_kz-0";